import React, { useState } from "react";
import {
  useTimesheetProvider,
} from "../../../Providers/Consultant/Timesheet";
import SidebarTab from "../../../Components/Sidebar/SidebarTab";
import { useLocation } from "react-router-dom";

const Sidebar = ({ profile, setProfile, activeLink }) => {
  const location = useLocation()
  const [active, setActive] = useState(activeLink || (location?.pathname?.split("card").length > 1 || location?.pathname?.split("project").length > 1) ? "dashboard" : location?.pathname?.split("/")[2] || "dashboard");
  const { setSelectedTimesheet } = useTimesheetProvider();

  return (
    <div className="flex md:flex-row grow">
      <div
        style={{
          width: "",
          paddingRight: "",
        }}
        className="sm:pl-8 h-full pl-6 fixed bg-white pb-[100px] overflow-x-visible"
      >
        <div className="flex flex-col space-y-2 overflow-y-scroll h-full scrollbar-hide">
          <SidebarTab value="dashboard" setActive={setActive} setProfile={setProfile} active={active} profile={profile} />
          <SidebarTab value="find-jobs" setActive={setActive} setProfile={setProfile} active={active} profile={profile} />
          <SidebarTab value="timesheets" setSelectedTimesheet={setSelectedTimesheet} setActive={setActive} setProfile={setProfile} active={active} profile={profile} />
          <SidebarTab value="my-jobs" setActive={setActive} setProfile={setProfile} active={active} profile={profile} />
          <SidebarTab value="my-account" setActive={setActive} setProfile={setProfile} active={active} profile={profile} />
        </div>
      </div>
    </div>
  );
};

const SidebarWrapper = (props) => {
  return (
    <Sidebar {...props} />
  );
};

export default SidebarWrapper;
